import ProductMain from './Main';

export default ProductMain;
